import {
  CustomerValidationError,
  CustomerValidationErrorProblem
} from './integrationCustomer.types'

const VALIDATION_FIELD_LABELS: Record<string, string> = {
  legalName: 'Company name',
  address: 'Address',
  'address.line1': 'Address line 1',
  'address.city': 'City',
  'address.postCode': 'Postal code',
  'address.country': 'Country',
  'address.state': 'State',
  email: 'Primary email'
}

export const getValidationFieldLabels = (
  validationErrors: CustomerValidationError[] | undefined,
  problem: CustomerValidationErrorProblem
): string[] =>
  (validationErrors ?? [])
    .filter(error => error.problem === problem)
    .map(error => VALIDATION_FIELD_LABELS[error.field] ?? error.field)
